import React from 'react';
import {Icons} from '../../assets';

export enum BlendMode {
  MULTIPLY = 'multiply',
  OVERLAY = 'overlay',
  SCREEN = 'screen',
  NORMAL = 'normal',
}

interface BackgroundPatternProps {
  src?: string;
  alt?: string;
  blendMode?: BlendMode;
  scale?: number;
  className?: string;
}

export const BackgroundPattern: React.FC<BackgroundPatternProps> = ({
  src = Icons.VECTOR_PATTERN,
  alt = 'Vector Pattern',
  blendMode = BlendMode.MULTIPLY,
  scale = 1.2,
  className = '',
}) => {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      <div className="absolute inset-0 w-full h-full">
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover"
          style={{
            mixBlendMode: blendMode,
            transform: `scale(${scale})`,
            transformOrigin: 'center',
          }}
        />
      </div>
    </div>
  );
};
